/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription, filter } from 'rxjs';

declare global {
  interface Window {
    voiceflow?: {
      chat: { load(config: any): void; open(): void; close(): void };
    };
    __voiceflowLoaded?: boolean;
  }
}
export {};

@Component({
  selector: 'app-chatbot',
  template: ''
})
export class ChatbotComponent implements OnInit, OnDestroy {
  private scriptEl?: HTMLScriptElement;
  private navSub?: Subscription;
  private originalBodyChildren!: Node[];

  constructor(
    private renderer: Renderer2,
    private router: Router,
  ) {}

ngOnInit(): void {
  this.originalBodyChildren = Array.from(document.body.childNodes);

  this.navSub = this.router.events
    .pipe(filter(e => e instanceof NavigationStart))
    .subscribe((event: NavigationStart) => {
      const isLogin = event.url.startsWith('/login');
      this.cleanupVoiceflow();

      document.body.classList.toggle('hide-chatbot', isLogin); // 👈

      if (!isLogin) {
        this.injectWidget();
      }
    });

  const isInitialLogin = this.router.url.startsWith('/login');
  document.body.classList.toggle('hide-chatbot', isInitialLogin); // 👈

  if (!isInitialLogin) {
    this.injectWidget();
  }
}


  ngOnDestroy(): void {
    this.navSub?.unsubscribe();
    this.cleanupVoiceflow();
  }

private injectWidget() {
  window.__voiceflowLoaded = false;

  this.scriptEl = this.renderer.createElement('script');
  this.scriptEl.type = 'text/javascript';
  this.scriptEl.src = 'https://cdn.voiceflow.com/widget-next/bundle.mjs';

  this.scriptEl.onload = () => {
    try {
      window.voiceflow?.chat.load({
        verify: { projectID: '67f51fd5f97fc159595ee5ae' },
        url: 'https://general-runtime.voiceflow.com',
        versionID: 'production',
        assistant: {
          inputPlaceholder: 'Mensaje..',
          stylesheet: `${window.location.origin}/assets/css/voiceflow-widget.css`
        }
      });
    } catch (e) {
      console.error('[Chatbot] Error al cargar Voiceflow:', e);
    }
  };

  this.renderer.appendChild(document.body, this.scriptEl);
}



  private cleanupVoiceflow() {
    console.log('[Chatbot] cleanupVoiceflow');

    try { window.voiceflow?.chat.close(); } catch {}

    delete window.voiceflow;
    window.__voiceflowLoaded = false;

    if (this.scriptEl?.parentNode) {
      console.log('[Chatbot] removiendo <script>');
      this.scriptEl.parentNode.removeChild(this.scriptEl);
      this.scriptEl = undefined;
    }

    Array.from(document.body.childNodes).forEach(node => {
      if (!this.originalBodyChildren.includes(node)) {
        console.log('[Chatbot] eliminando nodo extra de <body>:', node);
        node.remove();
      }
    });
  }
}
